import { Controller, useFieldArray } from 'react-hook-form';
import { Col, Empty, Form as AntForm, Row, TimePicker } from 'antd';
import styled from 'styled-components';
import { MinusCircleOutlined } from '@ant-design/icons';
import { AddIntervalButton, SingleTimeSlotConfigurationProps } from '@modules/timetable';
import { HSMSCheckBox } from '@components/shared';

const { Item: FormItem } = AntForm;

const RemoveIcon = styled.div`
  margin-top: 29px;
`;

const SingleTimeSlotConfigurationRow = styled(Row)`
  .ant-row {
    margin: -4px -4px -2px;
  }

  .ant-form-item-label {
    margin-bottom: -10px;
  }

  .interval-check-box {
    margin-top: 28px;
  }
`;

export const SingleTimeSlotConfiguration = ({ name, control, errors }: SingleTimeSlotConfigurationProps) => {
  const { fields, append, remove } = useFieldArray({ control, name });

  if (fields.length === 0) {
    return (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No intervals defined for this day.">
        <AddIntervalButton size="middle" append={append} />
      </Empty>
    );
  }

  return (
    <>
      {fields.map((field, index) => (
        <SingleTimeSlotConfigurationRow key={field.id} gutter={[{ xs: 8, sm: 8, md: 8, lg: 8 }, 8]}>
          <Col span={8}>
            <FormItem
              label="Start time"
              labelCol={{ span: 24 }}
              validateStatus={errors[name] && errors[name][index] && errors[name][index]?.startTime ? 'error' : ''}
              help={errors[name] && errors[name][index] && errors[name][index]?.startTime?.message}
            >
              <Controller
                as={<TimePicker format="HH:mm" />}
                name={`${name}[${index}].startTime`}
                control={control}
                defaultValue={field.startTime}
              />
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem
              label="End time"
              labelCol={{ span: 24 }}
              validateStatus={errors[name] && errors[name][index] && errors[name][index]?.endTime ? 'error' : ''}
              help={errors[name] && errors[name][index] && errors[name][index]?.endTime?.message}
            >
              <Controller
                as={<TimePicker format="HH:mm" />}
                name={`${name}[${index}].endTime`}
                control={control}
                defaultValue={field.endTime}
              />
            </FormItem>
          </Col>

          <Col span={5}>
            <div className="interval-check-box">
              <HSMSCheckBox name={`${name}[${index}].interval`} label="Interval?" control={control} />
            </div>
          </Col>

          <Col span={3}>
            <RemoveIcon>
              <MinusCircleOutlined
                className="dynamic-delete-button"
                onClick={() => {
                  remove(index);
                }}
              />
            </RemoveIcon>
          </Col>
        </SingleTimeSlotConfigurationRow>
      ))}
      <Row>
        <Col
          style={{
            marginTop: 12,
          }}
          span={4}
        >
          <AddIntervalButton size="small" append={append} />
        </Col>
        <br />
        <br />
      </Row>
    </>
  );
};
